import { render, staticRenderFns } from "./ordenMedicamentoComponent.vue?vue&type=template&id=0a61b5bc"
import script from "./ordenMedicamentoComponent.vue?vue&type=script&lang=js"
export * from "./ordenMedicamentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports